// @generated by protoc-gen-es v1.3.3 with parameter "target=js+dts,import_extension=none"
// @generated from file merchant/v1/payment_link.proto (package merchant.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import { proto3 } from "@bufbuild/protobuf";
import { Product } from "./product_pb";
import { Timestamp } from "../../google/protobuf/timestamp_pb";

/**
 * Defines possible status for Payment Links
 *
 * @generated from enum merchant.v1.LinkStatus
 */
export const LinkStatus = proto3.makeEnum(
  "merchant.v1.LinkStatus",
  [
    {no: 0, name: "LINK_STATUS_UNSPECIFIED", localName: "UNSPECIFIED"},
    {no: 1, name: "LINK_STATUS_ACTIVE", localName: "ACTIVE"},
    {no: 2, name: "LINK_STATUS_PAID", localName: "PAID"},
    {no: 3, name: "LINK_STATUS_INACTIVE", localName: "INACTIVE"},
    {no: 4, name: "LINK_STATUS_EXPIRED", localName: "EXPIRED"},
    {no: 5, name: "LINK_STATUS_PENDING", localName: "PENDING"},
  ],
);

/**
 * @generated from message merchant.v1.LinkItem
 */
export const LinkItem = proto3.makeMessageType(
  "merchant.v1.LinkItem",
  () => [
    { no: 1, name: "product", kind: "message", T: Product },
    { no: 2, name: "quantity", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 3, name: "unit_price", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
  ],
);

/**
 * Main resource for Payment Link representing single use link created by Merchant
 * and payable by their Customers.
 *
 * @generated from message merchant.v1.PaymentLink
 */
export const PaymentLink = proto3.makeMessageType(
  "merchant.v1.PaymentLink",
  () => [
    { no: 1, name: "link_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "merchant_order_number", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "description", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "items", kind: "message", T: LinkItem, repeated: true },
    { no: 6, name: "status", kind: "enum", T: proto3.getEnumType(LinkStatus) },
    { no: 7, name: "url", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 8, name: "expiration_timestamp", kind: "message", T: Timestamp },
    { no: 9, name: "total_transaction_amount", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 10, name: "currency_code", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 11, name: "creation_timestamp", jsonName: "createdTimestamp", kind: "message", T: Timestamp },
    { no: 12, name: "purchase_order_number", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 13, name: "is_partial_paid", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 14, name: "partial_auth_detail", kind: "message", T: PartialAuthDetail, repeated: true },
  ],
);

/**
 * @generated from message merchant.v1.PartialAuthDetail
 */
export const PartialAuthDetail = proto3.makeMessageType(
  "merchant.v1.PartialAuthDetail",
  () => [
    { no: 1, name: "partial_authorization", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 2, name: "requested_authorization_amount", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 3, name: "total_authorized_amount", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 4, name: "partial_authorization_support", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

